<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                @click="printAllPurchaseAnalysis('printAllPurchaseAnalysis')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromIssueDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.fromIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toIssueDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.toIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="supplierName"
                label="Supplier Name"
                type="text"
                v-model="queryParams.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="code"
                label="Supplier Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="purchaseOrderTypeList"
                label="Choose Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-data-table
          :must-sort="true"
          :headers="headers"
          :items="purchaseOrderList"
          class="elevation-1"
          :loading="showListLoading"
          :total-items="totalRows"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.supplierNo }}</td>
            <td>{{ props.item.supplierName }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.supplierAddress }}</td>
            <td style="text-align: right">
              {{ props.item.supplierAmount | decFormat(6) }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="printAllPurchaseAnalysis"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Purchase Analysis (Supplier) Report
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ this.queryParams.fromIssueDate | formatDate }}] To
          Date: [{{ this.queryParams.toIssueDate | formatDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 14px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Supplier No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Supplier Name
              </th>
              <th style="border: 1px solid black; text-align: center">Type</th>
              <th style="border: 1px solid black; text-align: center">
                Address
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody v-for="(header, index) in allPurchaseOrderList" :key="index">
            <td style="border: 1px solid black; text-align: left">
              {{ header.supplierNo }}
            </td>
            <td style="border: 1px solid black; text-align: left">
              {{ header.supplierName }}
            </td>
            <td style="border: 1px solid black; text-align: left">
              {{ header.type }}
            </td>
            <td style="border: 1px solid black; text-align: left">
              {{ header.supplierAddress }}
            </td>
            <td style="border: 1px solid black; text-align: right">
              {{ header.supplierAmount | decFormat(6) }}
            </td>
          </tbody>
          <td
            style="
              border: 1px solid black;
              font-weight: bold;
              text-align: right;
            "
            colspan="4"
          >
            Grand Total
          </td>
          <td
            style="
              border: 1px solid black;
              font-weight: bold;
              text-align: right;
            "
          >
            {{ totalAmount | decFormat(6) }}
          </td>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { purchaseOrderService } from "../../services/purchase-order-service";
import { commonService } from "../../services/common-service";

export default {
  name: "PurchaseAnalysisReport",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    showListLoading: false,
    printAllButtonLoading: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Purchase Analysis (Supplier) Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Supplier No", align: "left", value: "code" },
      { text: "Supplier Name", value: "company_name" },
      { text: "Type", value: "po.purchase_order_type" },
      { text: "Address", value: "address" },
      { text: "Amount", align: "right", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "code",
      totalItems: 0,
    },
    purchaseOrderTypeList: [
      { label: "----All----", value: "" },
      { label: "RAW", value: "RAW" },
      { label: "ASSET", value: "ASSET" },
    ],
    queryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      companyName: "",
      code: "",
      type: "",
    },
    totalRows: 0,
    totalAmount: 0,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    purchaseOrderList: [],
    allPurchaseOrderList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    // if (this.user.roleName == "WAREHOUSE_MANAGER") {
    //   this.queryParams.warehouseId = this.user.warehouse.id;
    // }
    if (this.$route.query.fromIssueDate) {
      this.queryParams.fromIssueDate = this.$route.query.fromIssueDate;
    }
    if (this.$route.query.toIssueDate) {
      this.queryParams.toIssueDate = this.$route.query.toIssueDate;
    }
    if (this.$route.query.companyName) {
      this.queryParams.companyName = this.$route.query.companyName;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.rowsPerPage) {
      this.pagination.rowsPerPage = this.$route.query.rowsPerPage;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "purchase-analysis-report",
        query: this.queryParams,
      });
      this.getPurchaseOrderList();
    },
    getPurchaseOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPurchaseAnalysisListBySupplier(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.totalRows = res.data.totalElements;
            this.totalAmount = res.data.totalAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAllPurchaseAnalysis(divName) {
      this.printAllButtonLoading = true;
      purchaseOrderService
        .getPurchaseAnalysisListBySupplier(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allPurchaseOrderList = res.data.data;
            this.totalAmount = res.data.totalAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>